<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gZmtID/tc-custom/9781467443227.jpg?1730409871754" alt="This image is the cover for the book With All Our Prayers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">With All Our Prayers
      </h1>
      <p class="bookDescription body article font2">
        <p>A resource for both corporate worship and personal devotion, <i>With All Our Prayers</i> invites readers to pray, think, and live into God’s purpose for the world and for their own lives. Written by a longtime Presbyterian pastor, the beautiful prayers in this book are theologically grounded in God’s steadfast love and invincible grace and contain traditional elements of adoration, confession, thanksgiving, petition, and intercession.<br/><br/>In this helpful volume church leaders will find prayers ordered around the liturgical calendar with themes appropriate to the seasons of the church year. Individuals and prayer groups will find guidance in praying for church and world, in interceding on behalf of strangers and enemies as well as loved ones and friends.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John B. Rogers
      </h2>
      
      <p class="authorDescription body article">John B. Rogers Jr. is a retired Presbyterian pastor living in Montreat, North Carolina. His previous books include <I>In Him Is Life: How Christ Meets Our Deepest Needs.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6970884b